import { calcColumnOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/columnConfig'
import { calcBarOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/barConfig'
import { calcPieOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/pieConfig'
import { calcStackedColumnOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/stackedColumnConfig'
import { calcStackedBarOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/stackedBarConfig'
import { calcAreaOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/areaConfig'
import { calcScatterOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/scatterConfig'
import { calcBubbleOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/bubbleConfig'
import { calcSunburstOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/sunburstConfig'
import { calcTreemapOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/treemapConfig'
import { calcEmdLineOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/emdLineConfig'
import {
  calcDataLabColumnsOptions,
  calcDataLabStackedOptions,
  calcDataLabBColumnsOptions,
  calcDataLabBStackedOptions
} from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/dataLabColumnsConfig'
import { calcDrawableChartMode } from '@aytm/app/stats/page/question-views/components/lib/chart-modes'

const CHART_BUILDERS = {
  respondents: calcColumnOptions,
  percents: calcColumnOptions,
  brespondents: calcBarOptions,
  bpercents: calcBarOptions,
  pie: calcPieOptions,
  stacked_pie: calcStackedColumnOptions,
  stacked_respondents: calcStackedColumnOptions,
  stacked_percents: calcStackedColumnOptions,
  stacked_brespondents: calcStackedBarOptions,
  stacked_bpercents: calcStackedBarOptions,
  area: calcAreaOptions,
  scatter: calcScatterOptions,
  bubble: calcBubbleOptions,
  sunburst: calcSunburstOptions,
  treemap: calcTreemapOptions,
  emdline: calcEmdLineOptions,

  // Data Lab Columns (grouped/stacked × column/bar)
  dl_columns: calcDataLabColumnsOptions,
  dl_stacked: calcDataLabStackedOptions,
  dl_bcolumns: calcDataLabBColumnsOptions,
  dl_bstacked: calcDataLabBStackedOptions
}

export const getChartBuilder = chartMode => CHART_BUILDERS[chartMode] || null

// The chart a report draws when it names none of its own
const DEFAULT_MODE = 'respondents'

// The last guard before drawing: a mode with no chart builder is fitted, by the one rule every resolver
// ends on, to the offered modes that have one, the report's default column chart first.
export const resolveDrawableMode = (chartMode, chartModeTypes = []) =>
  getChartBuilder(chartMode)
    ? chartMode
    : calcDrawableChartMode(
        chartMode,
        (chartModeTypes ?? []).filter(mode => getChartBuilder(mode)),
        { globalChartMode: DEFAULT_MODE }
      )
